import React, { useCallback, useEffect } from "react";
import { Alerts, $alerts } from "@pickit/pickit-components";
import "component/modal/notificationModal.scss";
import { connect } from "react-redux";
import {
  actions as notificationActions,
  notificationSelector,
} from "reducers/notification";
import { AppDispatch, RootState } from "store";
import { NotificationType } from "./types";
import { useTranslation } from "react-i18next";

export const NotificationModal = ({
  id = "notification",
  isOpen,
  level,
  title,
  onClose,
  onCancel,
  onConfirm,
  setClose,
  doAction,
  body,
  onCancelLabel,
  onConfirmLabel,
}: NotificationType) => {
  const { t } = useTranslation();
  const onCloseHandler = useCallback(() => {
    if (onClose) doAction(onClose);
    else setClose();
  }, [doAction, onClose, setClose]);

  const onCancelHandler = useCallback(() => {
    if (onCancel) doAction(onCancel);
    else setClose();
  }, [doAction, onCancel, setClose]);

  const onConfirmHandler = useCallback(() => {
    if (onConfirm) doAction(onConfirm);
    else setClose();
  }, [doAction, onConfirm, setClose]);

  useEffect(() => {
    if (isOpen) {
      $alerts.next({
          testId: id,
          title: title || "",
          type: level || "info",
          isMobile: false,
          onCancelLabel: t(onCancelLabel || ""),
          onCancel: onCancelHandler,
          onConfirmLabel: t(onConfirmLabel || ""),
          onConfirm: onConfirmHandler,
          onClose: onCloseHandler,
          subMessage: body,
        });
    }
  }, [
    id,
    body,
    isOpen,
    level,
    onConfirmLabel,
    onCancelLabel,
    title,
    onCancelHandler,
    onConfirmHandler,
    onCloseHandler,
    t,
  ]);

  return <Alerts />;
};

const mapStateToProps = (state: RootState) => ({
  id: notificationSelector(state).id || undefined,
  isOpen: notificationSelector(state).open || false,
  onCancelLabel: notificationSelector(state).onCancelLabel,
  onConfirmLabel: notificationSelector(state).onConfirmLabel,
  level: notificationSelector(state).level,
  title: notificationSelector(state).title,
  body: notificationSelector(state).body,
  onConfirm: notificationSelector(state).onConfirm,
  onCancel: notificationSelector(state).onCancel,
  onClose: notificationSelector(state).onClose,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  setClose: () => {
    dispatch(notificationActions.hideNotification());
  },
  doAction: (action: Function | undefined) => {
    action && action();
    dispatch(notificationActions.hideNotification());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationModal);
